// src/components/RecipeCardSkeleton.tsx
import React from 'react';
import { Box, Card, Flex, Skeleton } from '../ui';

const RecipeCardSkeleton: React.FC = () => {
  return (
    <Card data-testid="skeleton-card" fullHeight position="relative" className="skeleton-card">
      {/* Skeleton for image */}
      <Skeleton
        data-testid="skeleton-image"
        text={false}
        cardImageTop
        fullHeight
        className="skeleton-image"
      />

      {/* Skeleton for author info */}
      <Flex
        align="center"
        position="absolute"
        top={0}
        start={0}
        padding={2}
        style={{ zIndex: 10, background: 'rgba(0, 0, 0, 0.4)', borderRadius: '0 0 8px 0' }}
      >
        <Skeleton
          data-testid="skeleton-avatar"
          className="skeleton-avatar"
          marginEnd={2}
          circle
          width="32px"
          height="32px"
        />
        <Skeleton data-testid="skeleton-author-text" width="100px" height="16px" />
      </Flex>

      {/* Skeleton for label/title */}
      <Box
        data-testid="recipe-title-overlay-skeleton"
        className="recipe-title-overlay"
        position="absolute"
        top={50}
        start={50}
        positionTranslate="middle"
      >
        <Skeleton
          data-testid="skeleton-title-text"
          width="80%"
          height="24px"
          marginBottom={2}
        />
      </Box>

      {/* Skeleton for favorite button */}
      <Box position="absolute" top={0} end={0} padding={2} style={{ zIndex: 15 }}>
        <Skeleton
          data-testid="skeleton-favorite-button"
          className="skeleton-favorite-button"
          circle
          width="40px"
          height="40px"
        />
      </Box>
    </Card>
  );
};

export default RecipeCardSkeleton;
